var _filter, _filter2, _rect, _rect2, _text, _text2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _circle, _circle2, _circle3, _circle4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgenticMesh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1d4ed8"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshGrad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7c3aed"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshGrad3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ec4899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#db2777"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshGrad4",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#22c55e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#16a34a"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshGrad5",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d97706"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshGrad6",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#06b6d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0891b2"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "meshShadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 3,
    stdDeviation: 4,
    floodOpacity: 0.4
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "meshGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "#0f172a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 760,
    height: 410,
    rx: 20,
    fill: "#1e293b",
    opacity: 0.3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 50,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: "bold"
  }, "Agentic Mesh Architecture")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 75,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "Multiple agents collaborating in a distributed network")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 160,
    x2: 400,
    y2: 120,
    stroke: "#475569",
    strokeWidth: 1.5,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,300;150,300",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 120,
    x2: 600,
    y2: 160,
    stroke: "#475569",
    strokeWidth: 1.5,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,300;150,300",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.3s"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 160,
    x2: 650,
    y2: 280,
    stroke: "#475569",
    strokeWidth: 1.5,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,300;150,300",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.6s"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 650,
    y1: 280,
    x2: 550,
    y2: 380,
    stroke: "#475569",
    strokeWidth: 1.5,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,300;150,300",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.9s"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 380,
    x2: 250,
    y2: 380,
    stroke: "#475569",
    strokeWidth: 1.5,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,300;150,300",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 380,
    x2: 150,
    y2: 280,
    stroke: "#475569",
    strokeWidth: 1.5,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,300;150,300",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "1.5s"
  }))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 280,
    x2: 200,
    y2: 160,
    stroke: "#475569",
    strokeWidth: 1.5,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,300;150,300",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "1.8s"
  }))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 160,
    x2: 550,
    y2: 380,
    stroke: "#475569",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,500;250,500",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 120,
    x2: 250,
    y2: 380,
    stroke: "#475569",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,500;250,500",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }))), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 160,
    x2: 150,
    y2: 280,
    stroke: "#475569",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,500;250,500",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "1s"
  }))), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 650,
    y1: 280,
    x2: 200,
    y2: 160,
    stroke: "#475569",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,500;250,500",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "1.5s"
  }))), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 120,
    x2: 650,
    y2: 280,
    stroke: "#475569",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,500;250,500",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "2s"
  }))), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 280,
    x2: 550,
    y2: 380,
    stroke: "#475569",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,500;250,500",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "2.5s"
  }))), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 200,
    y2: 160,
    stroke: "#64748b",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 400,
    y2: 120,
    stroke: "#64748b",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.3s"
  }))), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 600,
    y2: 160,
    stroke: "#64748b",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.6s"
  }))), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 650,
    y2: 280,
    stroke: "#64748b",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.9s"
  }))), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 550,
    y2: 380,
    stroke: "#64748b",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }))), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 250,
    y2: 380,
    stroke: "#64748b",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.5s"
  }))), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 250,
    x2: 150,
    y2: 280,
    stroke: "#64748b",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.8s"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#3b82f6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "200;400",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "160;250",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#8b5cf6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "400;600",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "120;160",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#ec4899"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "650;400",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "280;250",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "550;250",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "380;380",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.5s"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 160)",
    filter: "url(#meshShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "url(#meshGrad1)",
    filter: "url(#meshGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "35;38;35",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 9
  }, "Research"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 8,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Agent"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 120)",
    filter: "url(#meshShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "url(#meshGrad2)",
    filter: "url(#meshGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "35;38;35",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 9
  }, "Coordinator"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 8,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Agent"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 160)",
    filter: "url(#meshShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "url(#meshGrad3)",
    filter: "url(#meshGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "35;38;35",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "1s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 9
  }, "Writer"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 8,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Agent"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 280)",
    filter: "url(#meshShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "url(#meshGrad4)",
    filter: "url(#meshGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "35;38;35",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "1.5s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 9
  }, "Reviewer"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 8,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Agent"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(550, 380)",
    filter: "url(#meshShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "url(#meshGrad5)",
    filter: "url(#meshGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "35;38;35",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "2s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 9
  }, "Publisher"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 8,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Agent"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 380)",
    filter: "url(#meshShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "url(#meshGrad6)",
    filter: "url(#meshGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "35;38;35",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "2.5s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 9
  }, "Analyst"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 8,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Agent"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 280)",
    filter: "url(#meshShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "#64748b",
    filter: "url(#meshGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "35;38;35",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "3s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 9
  }, "Database"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 8,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Agent"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 250)",
    filter: "url(#meshShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "#1e293b",
    stroke: "#94a3b8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 9
  }, "Message"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 8,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Bus"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "30;60",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "30;60",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenticMesh);
export default __webpack_public_path__ + "static/media/agentic-mesh.4cbaa17175ebb00894d89dd5d0057a8b.svg";
export { ForwardRef as ReactComponent };